import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { PurchasePaymentsProps } from "../../types/purchasePayments";
import { PurchasePartiesProps } from "../../types/purchaseParties";

export interface PurchasePaymentsState {
  party: PurchasePartiesProps;
  payments: PurchasePaymentsProps[];
  totalPayments: number;
  totalInvoice: number;
  totalPaymnet: number;
  totalNoteAmount: number;
  totalAmount: number;
  isCreateModalOpen: number;
  editPayment: PurchasePaymentsProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: PurchasePaymentsState = {
  party: {} as PurchasePartiesProps,
  payments: [],
  totalPayments: 0,
  totalInvoice: 0,
  totalPaymnet: 0,
  totalNoteAmount: 0,
  totalAmount: 0,
  isCreateModalOpen: 0,
  editPayment: null,
  loading: false,
  error: null,
};

type FetchPurchasePaymentsListDataProps = {
  id: string;
  queryParams: {
    page: number;
    size?: number;
    fromDate?: string | null;
    toDate?: string | null;
  };
};

export const fetchPurchasePaymentsListData = createAsyncThunk(
  "fetchPurchasePaymentsListData",
  async (req: FetchPurchasePaymentsListDataProps) => {
    let response: any;
    await GET(`/v1/admin/purchase-payments/${req.id}`, { ...req.queryParams })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const purchasePaymentsSlice = createSlice({
  name: "purchasePayments",
  initialState,
  reducers: {
    togglePurchaseCreateModal: (state, action: PayloadAction<number>) => {
      state.isCreateModalOpen = action.payload;
    },
    setEditPurchasePayment: (
      state,
      action: PayloadAction<PurchasePaymentsProps | null>
    ) => {
      state.editPayment = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchPurchasePaymentsListData.pending,
      (state, action: any) => {
        state.payments = [];
        state.loading = true;
        state.error = null;
      }
    );
    builder.addCase(
      fetchPurchasePaymentsListData.fulfilled,
      (state, action: any) => {
        state.loading = false;
        if (action.payload.data.status === "success") {
          state.party = action.payload.data.data.party;
          state.payments = action.payload.data.data.records;
          state.totalPayments = action.payload.data.data.total_records;
          state.totalInvoice = action.payload.data.data.total_invoice;
          state.totalPaymnet = action.payload.data.data.total_paymnet;
          state.totalNoteAmount = action.payload.data.data.total_note_amount;
          state.totalAmount = action.payload.data.data.total_amount;
          state.error = null;
        } else {
          state.party = {} as PurchasePartiesProps;
          state.payments = [];
          state.totalInvoice = 0;
          state.totalPaymnet = 0;
          state.totalNoteAmount = 0;
          state.totalAmount = 0;
          state.error =
            action?.payload?.data?.message ||
            "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
        }
      }
    );
    builder.addCase(
      fetchPurchasePaymentsListData.rejected,
      (state, action: any) => {
        state.payments = [];
        state.loading = false;
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    );
  },
});

export const { togglePurchaseCreateModal, setEditPurchasePayment } =
  purchasePaymentsSlice.actions;

export const getPurchaseParty = (state: RootState) =>
  state.purchasePayments.party;

export const getPurchasePayments = (state: RootState) =>
  state.purchasePayments.payments;

export const getTotalPurchasePayments = (state: RootState) =>
  state.purchasePayments.totalPayments;

export const getTotalPurchaseInvoice = (state: RootState) =>
  state.purchasePayments.totalInvoice;

export const getTotalPurchasePaymnet = (state: RootState) =>
  state.purchasePayments.totalPaymnet;

export const getTotalPurchaseNoteAmount = (state: RootState) =>
  state.purchasePayments.totalNoteAmount;

export const getTotalPurchaseAmount = (state: RootState) =>
  state.purchasePayments.totalAmount;

export const getIsPurchaseCreateModalOpen = (state: RootState) =>
  state.purchasePayments.isCreateModalOpen;

export const getEditPurchasePayment = (state: RootState) =>
  state.purchasePayments.editPayment;

export default purchasePaymentsSlice.reducer;
